module.exports = __webpack_public_path__ + "img/login.7e1b00a6.png";